<template>
	<loading v-bind:loading="loading" />

	<sirit-right-menu size="md">
		<template v-slot:rightMenuContent>
			<div
				class="modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md"
			>
				<span
					@click="closeModal()"
					class="cursor-pointer font-bold text-xl hover:text-sirit_blue-400"
					>x</span
				>
				<span class="text-md ml-2 text-black mt-1">Cerrar</span>
			</div>

			<div
				class="w-full text-left pt-5 mb-3 md:px-5 sm:px-3 grid grid-cols-2"
			>
				<div>
					<h2 class="text-lg font-bold">
						Fra {{ item.clientReference }}
					</h2>
					<span class="text-md">{{ item.mainParticipant }}</span>
				</div>
				<div>
					<h2 class="text-lg font-bold text-right">
						{{
							item.debitBalance
								? global.formatAmount(item.debitBalance)
								: ""
						}}
					</h2>
				</div>
			</div>

			<div
				class="w-full flex flex-col text-left sm:pl-3 md:pl-9 md:pb-6 sm:pb-3 bg-gray-100"
				style="max-height: 64%"
			>
				<div
					v-if="comments.length > 0"
					id="messages"
					class="flex flex-col space-y-4 p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch"
				>
					<div
						v-for="item in comments"
						v-bind:key="item.id"
						v-bind:item="item"
						class="chat-message"
					>
						<div
							v-if="item.agentId !== null"
							class="flex items-start mb-5"
						>
							<img
								alt="logo"
								src="../../assets/TRECUPERA_newlogo.png"
								class="rounded-xl w-8"
							/>
							<div
								class="flex flex-col space-y-2 text-md max-w-xs mx-2 order-2 items-start"
							>
								<div>
									<span
										class="px-4 py-2 rounded-lg inline-block bg-white text-black"
										>{{ item.comment }}</span
									>
								</div>
								<div class="text-md text-black capitalize">
									{{
										global.getFormatDateComplete(
											item.creationDate,
											6
										)
									}}
									<span v-if="item.readDate !== null"
										><fa
											icon="check"
											class="cursor-pointer"
										/>
										visto</span
									>
								</div>
							</div>
						</div>

						<div v-else class="chat-message my-1">
							<div class="flex items-end justify-end">
								<div
									class="flex flex-col space-y-2 text-md max-w-xs mx-2 order-1 items-end"
								>
									<div>
										<span
											class="px-4 py-2 rounded-lg inline-block rounded-br-none bg-gray-300 text-black"
											>{{ item.comment }}</span
										>
									</div>
									<div class="text-md text-black capitalize">
										{{
											global.getFormatDateComplete(
												item.creationDate,
												6
											)
										}}
										<span v-if="item.readDate !== null"
											><fa
												icon="check"
												class="cursor-pointer"
											/>
											visto</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else-if="!loading && comments.length == 0"
					class="grid place-items-center mt-20 items-center"
				>
					<span class="inline-block align-middle"
						>No hay registros disponibles</span
					>
				</div>
			</div>
			<div class="w-full grid my-2 py-2 text-md border-2">
				<form @submit.prevent="submit()">
					<div
						class="w-full grid grid-cols-1 sm:grid-cols-6 px-2 sm:text-left text-center text-md"
					>
						<div class="sm:col-span-4">
							<textarea
								v-model="msg.comment"
								placeholder="Ingrese su mensaje"
								name=""
								id=""
								cols="30"
								rows="10"
								class="w-full h-14 py-5 px-2 mt-2 white rounded-l-xl border-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-sirit_blue-600"
							></textarea>
						</div>
						<div class="sm:col-span-2">
							<button
								:disabled="msg.comment === ''"
								type="submit"
								:class="[
									msg.comment === ''
										? 'bg-gray-400'
										: 'bg-sirit_blue-500 hover:bg-sirit_blue-600',
								]"
								class="w-10/12 h-14 text-white py-3 px-2 mt-2 m-2 rounded-r-md"
							>
								Enviar
							</button>
						</div>
					</div>
				</form>
			</div>
		</template>
	</sirit-right-menu>
</template>

<script lang="ts">
	import axios from "axios";
	import { reactive, toRefs } from "vue";
	import * as global from "@/api/global";
	import loading from "@/components/Commons/Loading.vue";
	import SiritRightMenu from "@/components/Commons/SiritRightMenu.vue";

	export default {
		name: "CommentModal",
		components: { loading, SiritRightMenu },
		props: {
			openModal: { type: Boolean, required: true, default: false },
			item: { type: String, required: true, default: "" },
		},
		emits: ["onFire"],

		setup(props: any, { emit }: any) {
			const state = global.state;

			interface comment {
				comments: Array<any>;
				loading: Boolean;
				msg: {
					debtorCaseId: String;
					comment: String;
				};
			}

			let data = reactive<comment>({
				comments: [],
				loading: false,
				msg: {
					debtorCaseId: "",
					comment: "",
				},
			});

			const data_alert = reactive({
				title: "",
				msg: "",
				description: "",
				type: "",
				open: false,
			});

			const closeModal = () => {
				emit("onFire");
			};

			let errors = reactive([
				{
					code: 16691464,
					msg: "1",
				},
			]);

			const getComments = async () => {
				data.loading = true;
				const url =
					process.env.VUE_APP_BASE_URL +
					`/Debtorcase/${props.item.id}/comments`;
				let response = null;
				try {
					response = await axios.get(url, {
						headers: {
							Authorization: `Bearer ${global.getToken()}`,
						},
					});
				} catch (e: any) {
					response = e.response;
				}

				if (response.status == 200) {
					data.comments = response.data.reverse();

					await readMsgs(response.data);

					await setTimeout(function () {
						state.readNotifications = false;
					}, 1000);
				} else {
					if (response.status == 401) {
						global.logout();
					}
					errors = response.data;
				}
				data.loading = false;
			};

			const setParticipantId = () => {
				data.msg.debtorCaseId = props.item.id;
			};

			const addComment = async () => {
				const url = process.env.VUE_APP_BASE_URL + "/Comment";
				let response = null;
				try {
					response = await axios.post(url, data.msg, {
						headers: {
							Authorization: `Bearer ${global.getToken()}`,
						},
					});
				} catch (e: any) {
					response = e.response;
				}

				return response;
			};

			const readComment = async (id: number) => {
				const msg = { id: id, read: true };
				const url = process.env.VUE_APP_BASE_URL + "/Comment/read";
				let response = null;
				try {
					response = await axios.put(url, msg, {
						headers: {
							Authorization: `Bearer ${global.getToken()}`,
						},
					});
				} catch (e: any) {
					response = e.response;
				}

				if (response.status == 200) {
					state.readNotifications = true;
				}

				return response;
			};

			const submit = async () => {
				data.loading = true;
				setParticipantId();
				let objec_res = { status: 0, data: { id: 0, message: "" } };
				let responsePhone = objec_res;

				responsePhone = await addComment();

				data_alert.open = true;

				if (responsePhone.status === 200) {
					data_alert.type = "success";
					data_alert.title = "Ok";
					data_alert.msg = `Teléfono registrado con éxito`;
					getComments();
				} else {
					if (responsePhone.status == 401) {
						global.logout();
					}
					data_alert.type = "danger";
					data_alert.title = "¡Error!";
					data_alert.msg = `Hubo un problema al tratar de registrar el teléfono`;
					data_alert.description = responsePhone.data.message;
				}
				data.loading = false;

				await resetForm();

				await setTimeout(function () {
					data_alert.open = false;
				}, 4000);
			};

			const resetForm = () => {
				data.msg.debtorCaseId = "";
				data.msg.comment = "";
			};

			const readMsgs = (arrayMsg: Array<any>) => {
				arrayMsg.map((item: any) => {
					if (item.readDate === null && item.agentId !== null) {
						readComment(item.id);
					}
				});
			};

			getComments();

			return {
				errors,
				closeModal,
				setParticipantId,
				getComments,
				addComment,
				submit,
				resetForm,
				global,
				readComment,
				readMsgs,
				...toRefs(data),
			};
		},
	};
</script>
